/**
 *
 * @param $stateProvider
 */
export function Router($stateProvider) {
	"ngInject";

	$stateProvider
		.state({
			name: "requests",
			url: "/app/requests",
			template: "<requests-fetch-all-component></requests-fetch-all-component>"
		})
		.state({
			name: "portalAddCompanyRequests",
			url: "/app/portalAddCompanyRequests",
			template: "<portal-add-company-requests-component></portal-add-company-requests-component>"
		})
		.state({
			name: "portalAddUserRequests",
			url: "/app/portalAddUserRequests",
			template: "<portal-add-user-requests-component></portal-add-user-requests-component>"
		})
		.state({
			name: "forbidden",
			url: "/app/no-access",
			template: "<no-access></no-access>"
		});
}


// WEBPACK FOOTER //
// ./sources/components/router.js